/* Rayelle theme script: menu, torch hero, light colour tabs, product options, cart API (add, upgrade swaps, Duo switch). */
(function () {
  'use strict';
  var routes = (window.Rayelle && window.Rayelle.routes) || { root: '/' };
  function url(path) { return (routes.root || '/').replace(/\/$/, '') + path; }

  /* ---------- mobile menu ---------- */
  var toggle = document.getElementById('menu-toggle'), nav = document.getElementById('mobile-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.hidden; nav.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    nav.addEventListener('click', function (e) { if (e.target.tagName === 'A') { nav.hidden = true; toggle.setAttribute('aria-expanded', 'false'); } });
  }

  /* ---------- cart helpers (Shopify AJAX cart API) ---------- */
  function getCart() { return fetch(url('/cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return fetch(url(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function setCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); });
    document.querySelectorAll('.cart-link').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
  }
  function flash(btn, text) {
    var old = btn.dataset.label || btn.textContent; btn.dataset.label = old;
    btn.textContent = text; btn.classList.add('added');
    setTimeout(function () { btn.textContent = old; btn.classList.remove('added'); }, 1600);
  }
  function qtyOf(cart, variantId) {
    return cart.items.filter(function (i) { return i.variant_id === +variantId; }).reduce(function (n, i) { return n + i.quantity; }, 0);
  }
  /* swap one unit of variant `from` for one unit of variant `to` in a single cart update (never a second mask) */
  function swap(from, to) {
    return getCart().then(function (cart) {
      var updates = {};
      var f = qtyOf(cart, from);
      if (from && f > 0) updates[from] = f - 1;
      updates[to] = qtyOf(cart, to) + 1;
      return post('/cart/update.js', { updates: updates });
    });
  }

  /* ---------- cart drawer: slides in from the right after Add to cart and from the bag icon ---------- */
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.querySelector('.drawer-overlay');
  var lastFocus = null;
  function money(cents) {
    var v = (cents || 0) / 100, cur = (window.Rayelle && window.Rayelle.currency) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + (v % 1 ? v.toFixed(2) : v); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function renderDrawer(cart) {
    if (!drawer) return;
    var list = drawer.querySelector('[data-drawer-items]'), empty = drawer.querySelector('[data-drawer-empty]'), foot = drawer.querySelector('[data-drawer-foot]');
    list.innerHTML = cart.items.map(function (it) {
      var v = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cd-var">' + esc(it.variant_title) + '</p>' : '';
      var img = it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="" width="72" height="96" loading="lazy">' : '<span class="cd-noimg"></span>';
      return '<li class="cd-item" data-key="' + esc(it.key) + '">' + img +
        '<div><p class="cd-name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' + v +
        '<div class="c-qty"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="One less ' + esc(it.product_title) + '">\u2212</button><span aria-live="polite">' + it.quantity + '</span>' +
        '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="One more ' + esc(it.product_title) + '">+</button></div></div>' +
        '<div class="cd-right"><p class="c-price">' + money(it.final_line_price) + '</p><button type="button" class="c-remove" data-qty="0">Remove</button></div></li>';
    }).join('');
    empty.hidden = cart.item_count > 0; foot.hidden = cart.item_count === 0;
    drawer.querySelector('[data-drawer-subtotal]').textContent = money(cart.total_price);
    var ship = drawer.querySelector('[data-drawer-ship]');
    if (ship) ship.textContent = cart.total_price >= +ship.dataset.free ? ship.dataset.freeText : ship.dataset.paidText;
    setCount(cart.item_count);
  }
  function openDrawer(cart) {
    if (!drawer) { window.location.href = url('/cart'); return; }
    var go = function (c) {
      renderDrawer(c);
      lastFocus = document.activeElement;
      overlay.hidden = false; drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('drawer-open');
      requestAnimationFrame(function () { drawer.classList.add('open'); overlay.classList.add('open'); drawer.querySelector('.cd-close').focus(); });
    };
    if (cart) go(cart); else getCart().then(go);
  }
  function closeDrawer() {
    if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return;
    drawer.classList.remove('open'); overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('drawer-open');
    setTimeout(function () { overlay.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
      var link = e.target.closest('.cart-link');
      if (link) { e.preventDefault(); openDrawer(); return; }
      var q = e.target.closest('#cart-drawer [data-qty]');
      if (q) {
        var li = q.closest('.cd-item'); q.disabled = true;
        post('/cart/change.js', { id: li.dataset.key, quantity: +q.dataset.qty }).then(renderDrawer).catch(function () { q.disabled = false; });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (drawer.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') closeDrawer();
      if (e.key === 'Tab') {
        var f = drawer.querySelectorAll('a[href],button:not([disabled])'); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* add-to-cart forms (cards and product pages): stay on the page and open the cart drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var fd = new FormData(form), id = fd.get('id');
    if (!id) { form.submit(); return; }
    if (btn) btn.disabled = true;
    post('/cart/add.js', { items: [{ id: +id, quantity: +(fd.get('quantity') || 1) }] })
      .then(getCart).then(function (cart) { setCount(cart.item_count); if (btn) flash(btn, 'Added'); openDrawer(cart); })
      .catch(function (err) { if (btn) flash(btn, (err && err.description) || 'Not available'); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* upgrade and Duo buttons: data-swap-from (optional) + data-swap-to variant ids */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-swap-to]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    swap(b.dataset.swapFrom, b.dataset.swapTo).then(function (cart) {
      if (b.hasAttribute('data-reload')) { window.location.reload(); return; }
      setCount(cart.item_count); flash(b, b.dataset.done || 'Added'); b.disabled = false; openDrawer(cart);
    }).catch(function () { b.disabled = false; flash(b, 'Please try again'); });
  });

  /* ---------- product options: price, gallery and the variant posted to the cart ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var price = root.querySelector('[data-price-display]'), main = root.querySelector('[data-gallery-main]'), thumbs = root.querySelector('[data-gallery-thumbs]');
    function show(btn) {
      if (!btn || !main) return;
      main.src = btn.dataset.src; main.alt = btn.dataset.alt || '';
      if (btn.dataset.w) { main.width = +btn.dataset.w; main.height = +btn.dataset.h; }
      thumbs.querySelectorAll('.g-thumb').forEach(function (t) { t.setAttribute('aria-pressed', String(t === btn)); });
      var l = btn.offsetLeft - thumbs.offsetLeft, r = l + btn.offsetWidth;
      if (l < thumbs.scrollLeft) thumbs.scrollLeft = l - 4; else if (r > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollLeft = r - thumbs.clientWidth + 4;
    }
    function build(list) {
      if (!thumbs || !list || !list.length) return;
      thumbs.innerHTML = '';
      list.forEach(function (g, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'g-thumb';
        b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + list.length);
        b.dataset.src = g.src; b.dataset.alt = g.alt || ''; if (g.w) { b.dataset.w = g.w; b.dataset.h = g.h; }
        var im = new Image(); im.src = g.src; im.alt = ''; b.appendChild(im); thumbs.appendChild(b);
      });
      show(thumbs.firstChild);
      if (strip) strip.hidden = list.length < 2;
      thumbs.scrollLeft = 0; arrows();
    }
    var strip = root.querySelector('[data-gallery-strip]');
    function arrows() {
      if (!strip || !thumbs) return;
      var max = thumbs.scrollWidth - thumbs.clientWidth - 2;
      strip.querySelectorAll('[data-strip-move]').forEach(function (a) {
        a.disabled = a.dataset.stripMove < 0 ? thumbs.scrollLeft <= 2 : thumbs.scrollLeft >= max;
      });
    }
    if (strip) {
      strip.addEventListener('click', function (e) {
        var a = e.target.closest('[data-strip-move]'); if (!a) return;
        thumbs.scrollBy({ left: +a.dataset.stripMove * Math.max(thumbs.clientWidth * 0.8, 76), behavior: 'smooth' });
      });
      thumbs.addEventListener('scroll', arrows, { passive: true });
      window.addEventListener('resize', arrows);
    }
    if (thumbs) thumbs.addEventListener('click', function (e) { var t = e.target.closest('.g-thumb'); if (t) show(t); });
    var galleries = {};
    var data = root.querySelector('script[data-galleries]');
    if (data) { try { galleries = JSON.parse(data.textContent); } catch (err) { galleries = {}; } }
    var start = root.querySelector('input[name="id"]:checked') || root.querySelector('input[name="id"][type="hidden"]');
    if (start && galleries[start.value]) build(galleries[start.value]);
    root.querySelectorAll('input[name="id"][type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (price) price.textContent = r.dataset.price;
        if (galleries[r.value]) build(galleries[r.value]);
        if (window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); window.history.replaceState({}, '', u.toString()); }
      });
    });
  });

  /* ---------- torch hero ----------
     The mask-off photo (.hero-back) sits exactly on top of the mask-on photo (.hero-front), same size,
     object-fit and object-position. A feathered circle mask reveals it where the pointer or finger is.
     Before any interaction the torch drifts slowly over her face; the first touch or mouse move stops the drift. */
  function initTorch(hero) {
    if (hero._torch) hero._torch.stop();
    var media = hero.querySelector('.hero-media'), front = hero.querySelector('.hero-front'), back = hero.querySelector('.hero-back');
    if (!media || !front || !back) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var phoneMq = window.matchMedia('(max-width: 899px)');
    var face = {
      phone: { x: (+hero.dataset.facePhoneX || 50) / 100, y: (+hero.dataset.facePhoneY || 30) / 100 },
      desk: { x: (+hero.dataset.faceDeskX || 53) / 100, y: (+hero.dataset.faceDeskY || 39) / 100 }
    };
    var size = { desk: +hero.dataset.torchDesk || 200, phone: +hero.dataset.torchPhone || 140 };
    var cur = null, tgt = { x: 0, y: 0 }, user = false, drift = 0, raf = 0, last = 0, visible = true, stopped = false;

    function radius() { return phoneMq.matches ? size.phone : size.desk; }
    // where her face is inside the hero box, following object-fit: cover and the computed object-position
    function facePoint() {
      var IW = front.naturalWidth || (phoneMq.matches ? 600 : 1360), IH = front.naturalHeight || (phoneMq.matches ? 988 : 768);
      var f = phoneMq.matches ? face.phone : face.desk;
      var W = media.clientWidth, H = media.clientHeight, s = Math.max(W / IW, H / IH);
      var pos = (getComputedStyle(front).objectPosition || '50% 50%').split(' ');
      var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
      if (isNaN(px)) px = 0.5; if (isNaN(py)) py = 0.5;
      return { x: (W - IW * s) * px + f.x * IW * s, y: (H - IH * s) * py + f.y * IH * s, s: s };
    }
    function paint(x, y, r) {
      // set the whole gradient (not a CSS variable): Safari on iPhone does not repaint masks when only a variable changes
      var g = 'radial-gradient(circle ' + r.toFixed(1) + 'px at ' + x.toFixed(1) + 'px ' + y.toFixed(1) + 'px, #000 0%, #000 30%, rgba(0,0,0,.75) 48%, rgba(0,0,0,.35) 70%, rgba(0,0,0,0) 100%)';
      back.style.webkitMaskImage = g; back.style.maskImage = g;
    }
    function rel(clientX, clientY) { var r = media.getBoundingClientRect(); return { x: clientX - r.left, y: clientY - r.top }; }
    function onUser(clientX, clientY) {
      var p = rel(clientX, clientY);
      tgt.x = p.x; tgt.y = p.y;
      if (!user) { user = true; if (!cur) cur = { x: p.x, y: p.y }; }
      wake();
    }
    function onPointer(e) { onUser(e.clientX, e.clientY); }
    function onTouch(e) { var t = e.touches && e.touches[0]; if (t) onUser(t.clientX, t.clientY); }
    function frame(now) {
      raf = 0;
      if (stopped) return;
      var dt = last ? Math.min(64, now - last) : 16; last = now;
      if (!user) {
        var fp = facePoint();
        if (!reduce) drift += dt * 0.00042;
        var amp = Math.min(media.clientWidth, media.clientHeight) * 0.16;
        tgt.x = fp.x + Math.sin(drift) * amp;
        tgt.y = fp.y + Math.sin(drift * 1.7) * amp * 0.45;
      }
      if (!cur) cur = { x: tgt.x, y: tgt.y };
      var k = 1 - Math.pow(1 - (user ? 0.2 : 0.08), dt / 16);
      if (reduce && !user) k = 1;
      cur.x += (tgt.x - cur.x) * k; cur.y += (tgt.y - cur.y) * k;
      paint(cur.x, cur.y, radius());
      var moving = Math.abs(tgt.x - cur.x) > 0.3 || Math.abs(tgt.y - cur.y) > 0.3;
      if (visible && (moving || (!user && !reduce))) raf = requestAnimationFrame(frame);
    }
    function wake() { if (!raf && !stopped) { last = 0; raf = requestAnimationFrame(frame); } }

    hero.addEventListener('pointermove', onPointer);
    hero.addEventListener('pointerdown', onPointer);
    hero.addEventListener('touchstart', onTouch, { passive: true });
    hero.addEventListener('touchmove', onTouch, { passive: true });
    window.addEventListener('resize', wake);
    front.addEventListener('load', wake);
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) wake(); });
      io.observe(hero);
    }
    hero._torch = {
      stop: function () {
        stopped = true; if (raf) cancelAnimationFrame(raf);
        hero.removeEventListener('pointermove', onPointer); hero.removeEventListener('pointerdown', onPointer);
        hero.removeEventListener('touchstart', onTouch); hero.removeEventListener('touchmove', onTouch);
        window.removeEventListener('resize', wake); front.removeEventListener('load', wake);
        if (io) io.disconnect();
        hero._torch = null;
      }
    };
    wake();
  }
  function initTorches(scope) { (scope || document).querySelectorAll('[data-torch]').forEach(initTorch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTorches(); });
  else initTorches();
  // theme editor: re-run when the hero section is added, changed or re-ordered
  document.addEventListener('shopify:section:load', function (e) { initTorches(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-torch]').forEach(function (h) { if (h._torch) h._torch.stop(); });
  });

  /* ---------- email sign-up: after Shopify reloads the page, scroll to the thank-you message ---------- */
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    var msg = document.querySelector('#signup .form-msg');
    if (msg) msg.scrollIntoView({ block: 'center' });
  }

  /* ---------- light colour tabs: tapping a tab shows its photos and line ---------- */
  function initModeTabs(scope) {
    (scope || document).querySelectorAll('[data-mode-tabs]').forEach(function (box) {
      if (box._tabs) return; box._tabs = true;
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab, panel = document.getElementById(t.getAttribute('aria-controls'));
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
          if (n === null) return;
          e.preventDefault(); select(tabs[(n + tabs.length) % tabs.length], true);
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initModeTabs(); });
  else initModeTabs();
  document.addEventListener('shopify:section:load', function (e) { initModeTabs(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target.getAttribute && e.target.getAttribute('role') === 'tab') e.target.click();
  });

  /* ---------- muted videos: start playing once in view (some phones hold autoplay until then) ---------- */
  document.querySelectorAll('.vid video').forEach(function (v) {
    v.muted = true;
    var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
  });
  /* ---------- delivery estimate: today + 8 to 19 business days, skipping weekends ---------- */
  function addBusinessDays(d, n) {
    var r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function fmtDay(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  document.querySelectorAll('[data-eta]').forEach(function (el) {
    var now = new Date(), out = el.querySelector('[data-eta-range]');
    if (!out) return;
    out.textContent = fmtDay(addBusinessDays(now, +el.dataset.min || 8)) + ' \u2013 ' + fmtDay(addBusinessDays(now, +el.dataset.max || 19));
    el.hidden = false;
  });

  /* ---------- gentle fade-in on scroll ---------- */
  function initFades(root) {
    var els = (root || document).querySelectorAll('.fade:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  initFades();
  document.addEventListener('shopify:section:load', function (e) { initFades(e.target); });

  /* ---------- "Turn on the light" hero: tap a colour to crossfade its photo; auto-cycles until the first tap ---------- */
  function initLightHero(hero) {
    if (hero._lh) hero._lh.stop();
    var dots = [].slice.call(hero.querySelectorAll('[data-light]')), shots = hero.querySelectorAll('[data-shot]');
    if (!dots.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var secs = Math.max(2, +hero.dataset.cycle || 3), timer = null, current = 0, touched = false, visible = true;
    function set(n) {
      current = n; hero.dataset.on = String(n);
      shots.forEach(function (im) { im.classList.toggle('is-on', +im.dataset.shot === n); });
      dots.forEach(function (d) { d.setAttribute('aria-pressed', String(+d.dataset.light === n)); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduce || touched || timer || !visible || document.hidden) return;
      timer = setInterval(function () { set(current % dots.length + 1); }, secs * 1000);
    }
    hero.addEventListener('click', function (e) {
      var d = e.target.closest('[data-light]'); if (!d) return;
      touched = true; stop(); set(+d.dataset.light);
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) start(); else stop(); });
      io.observe(hero);
    }
    function vis() { if (document.hidden) stop(); else start(); }
    document.addEventListener('visibilitychange', vis);
    set(hero.querySelector('[data-shot="0"]') ? 0 : 1); start();
    hero._lh = { stop: function () { stop(); document.removeEventListener('visibilitychange', vis); if (io) io.disconnect(); } };
  }
  function initLightHeroes(scope) { (scope || document).querySelectorAll('[data-light-hero]').forEach(initLightHero); }
  initLightHeroes();
  document.addEventListener('shopify:section:load', function (e) { initLightHeroes(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest && e.target.closest('[data-light]'); if (d) d.click();
  });

  /* ---------- floating cart: stays out of the way while the hero colour buttons are on screen ---------- */
  (function () {
    var dots = document.querySelector('.lh-dots');
    if (!dots || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { document.documentElement.classList.toggle('fab-hide', en[0].isIntersecting); }).observe(dots);
  })();
})();
